import ScreenMedia from "scss/exports/mediaScreen.module.scss";

export const Media = ScreenMedia;
export const MediaNumbers = Object.entries(ScreenMedia).reduce((accumulator, currentValue) => {
	const [name, value] = currentValue
	return {
		...accumulator,
		[name]: Number(value.replace("px", ""))
	};
}, {});

export const settings = {
	imgTypes: ["webp", "jpeg"] as const,
	resizeStrategies: ["fill", "byWidth", "byHeight", "bestFit"] as const,
	screenSupport: {
		DPR: [1, 1.8, 2] /* density versions to supported and generated in the srcset */,
		pageSpeedMobileW: 412 /* Moto G power, DPR 1.8 */,
		pageSpeedDesktopW: 1350,
	},
};

export type BaseArgs = {
	type: (typeof settings.imgTypes)[number];
	src: string | null;
	arSizes?: number[];
	gravity?: string;
}

export type ByWidthArgs = BaseArgs & {
	width: number
}

export type ByHeightArgs = BaseArgs & {
	height: number

}

export type ByDimensionArgs = BaseArgs & {
	resizeStrategy: (typeof settings.resizeStrategies)[0 | 3];
	width: number
	height: number
}

export const buildFromHeight = ({
	type,
	src,
	height,
	arSizes,
	gravity
}: ByHeightArgs): string => {
	const { screenSupport: { DPR } } = settings
	const srcsetSizes = arSizes && arSizes.length > 0
		? [...new Set(arSizes.map(s => DPR.map((density) => Math.round(s * density))).flat())]
		: [...new Set(DPR.map((density) => Math.round(height * density)))]

	return srcsetSizes.map(size => `/image/sx${size}/${type}/file${src}?gravity=${gravity} ${size}w`).join(", ")
}

export const buildFromWidth = ({
	type,
	src,
	width,
	arSizes,
	gravity
}: ByWidthArgs): string => {
	const { screenSupport: { DPR } } = settings
	const srcsetSizes = arSizes && arSizes.length > 0
		? [...new Set(arSizes.map(s => DPR.map((density) => Math.round(s * density))).flat())]
		: [...new Set(DPR.map((density) => Math.round(width * density)))]

	return srcsetSizes.map(size => `/image/s${size}x/${type}/file${src}?gravity=${gravity} ${size}w`).join(", ")
}

export const buildFromDimensions = ({
	type,
	src,
	width,
	height,
	resizeStrategy = "fill",
	arSizes,
	gravity
}: ByDimensionArgs): string => {
	const { screenSupport: { DPR } } = settings

	const srcsetSizes = arSizes && arSizes.length > 0
		? [...new Set(arSizes.map(s => DPR.map((density) => Math.round(s * density))).flat())]
		: [...new Set(DPR.map((density) => Math.round(width * density)))]

	const strategy = resizeStrategy == "fill" ? "/fill" : "";

	return srcsetSizes.map(size => {
		const srcsetHeight = Math.round(size * (height / width))
		return `/image/s${size}x${srcsetHeight}${strategy}/${type}/file${src}?gravity=${gravity} ${size}w`;
	}).join(", ");
};
